import React, { useEffect, useState } from "react";
import { storeStateType, useAppDispatch } from "../../redux/store";
import {
  bulkWorktypeDelete,
  deleteWorktype,
  loadWorktypes,
} from "../../redux/actions/worktype.actions";
import { useSelector } from "react-redux";
import AddWorktypeModal from "./AddWorktypeModal";
import { WorktypeType } from "../../redux/reducers/worktype.reducer";
import { WORKTYPE_SAVE_NOT } from "../../redux/types/worktype.types";
import AlertDialog from "./AlertDialog";
import { Grid } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";

import { GridActionsCellItem } from "@mui/x-data-grid-pro";

import DeleteIcon from "@mui/icons-material/Delete";
import WithPermission from "../../components/WithPermission";
import CustomDataGridPro from "../../components/CustomDataGridPro/CustomDataGridPro";
import Item from "../../Template/Item";
import CustomGridHeader from "../../components/CustomGridHeader";

export type filterColumnType = {
  col: string;
  opt: string;
  value: string;
};

export type MultiFiltersType = {
  page: number;
  filters?: filterColumnType[];
  logicalOperator?: "and" | "or";
  q?: string;
  size: number;
};

export type SingleColumnFilterType = {
  col: string;
  opt: string;
  value: string;
  q: string;
  page: number;
  size: number;
};

export default function Worktype() {
  const [, setCurrentPage] = useState<number>(1);
  const [pageLimit, setPageLimit] = useState<number>(10);
  const [selectedWorktype, setSelectedWorktype] = useState<null | any>(null);
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
  const [selectedRows, setSelectedRows] = useState<string[]>([]);
  const [filterData, setFilterData] = React.useState<MultiFiltersType>({
    page: 1,
    size: 10,
  });

  //for showing modal to add new worktype
  const [showAddWorktypeModal, setShowAddWorktypeModal] =
    useState<boolean>(false);

  const dispatch = useAppDispatch();
  const { currentPage, worktypes, totalRows, save, loading } = useSelector(
    (state: storeStateType) => state.worktype
  );

  useEffect(() => {
    if (save) {
      setShowAddWorktypeModal(false);
      dispatch({ type: WORKTYPE_SAVE_NOT });
    } else {
      dispatch(loadWorktypes(filterData));
    }
  }, [dispatch, save, filterData]);

  const columns = [
    {
      field: "sn",
      headerName: "S.N",
      filterable: false,
      disableColumnMenu: true,
      disableRowSelectionOnClick: true,
      renderCell: (params: any) =>
        pageLimit * (currentPage - 1) + params?.row?.rowIndex + 1,
    },

    {
      field: "worktype",
      headerName: "Worktypes",
      minWidth: 250,
      flex: 1,
      filterMode: "server",
    },
    {
      field: "actions",
      type: "actions",
      minWidth: 20,
      flex: 0.1,
      getActions: (params: any) => [
        <GridActionsCellItem
          icon={<EditIcon />}
          label="Edit"
          onClick={() => {
            setSelectedWorktype(params.row);
            setShowAddWorktypeModal(true);
          }}
          showInMenu
          key="action-1"
        />,
        <GridActionsCellItem
          icon={<DeleteIcon />}
          label="Trash"
          showInMenu
          onClick={() => {
            setSelectedWorktype(params.row);
            setShowDeleteModal(true);
          }}
          // onClick={deleteCompany(params.id, customOptions)}
          key="action-2"
        />,
      ],
    },
  ];

  // const rows = worktypes?.map((worktype: WorktypeType, index: number) => {
  //   return { id: worktype.id, rowIndex: index, worktype: worktype.work_type };
  // });

  let rows =
    Array.isArray(worktypes) && worktypes?.length >= 0
      ? worktypes.map((worktype: WorktypeType, index: number) => {
          let _id = currentPage === 1 ? 1 : pageLimit * (currentPage - 1) + 1;
          return {
            id: worktype.id,
            sn: index + _id,
            rowIndex: index,
            worktype: worktype.work_type,
          };
        })
      : [];

  function handleConfirmDelete() {
    dispatch(deleteWorktype(selectedWorktype.id));
  }

  function handleRowSelectionModelChange(selectedRowIds: string[]) {
    setSelectedRows(selectedRowIds);
  }

  function handleAddWorktype() {
    setShowAddWorktypeModal(true);
  }

  function handleBulkDelete() {
    let formData = { id: selectedRows };
    dispatch(bulkWorktypeDelete(formData, filterData));
  }

  return (
    <>
      <Grid container gap={2}>
        <Grid item xs={12}>
          <WithPermission
            roleReqiured={["ADMIN", "EMPLOYEE", "STAFF", "USER"]}
            message="Access Denied"
          >
            <Item>
              <CustomGridHeader
                title={"worktype"}
                handleAddClick={handleAddWorktype}
                handleBulkDelete={handleBulkDelete}
                disabledTrashState={selectedRows.length <= 0}
              />
              <div style={{ height: 700, width: "100%" }}>
                <CustomDataGridPro
                  setFilterData={setFilterData}
                  loading={loading}
                  totalRows={totalRows}
                  rows={rows}
                  columns={columns}
                  filterData={filterData}
                  pageLimit={pageLimit}
                  defaultCSVExport={true}
                  currentPage={currentPage}
                  setPageLimit={setPageLimit}
                  setCurrentPage={setCurrentPage}
                  disableRowSelectionOnClick={true}
                  handleRowSelectionModelChange={handleRowSelectionModelChange}
                  csvFilename={`worktype`}
                />
              </div>
            </Item>
          </WithPermission>
        </Grid>
      </Grid>
      {showAddWorktypeModal && (
        <AddWorktypeModal
          titleName={`worktype`}
          setShowAddWorktypeModal={setShowAddWorktypeModal}
          selectedWorktype={selectedWorktype}
        />
      )}
      <AlertDialog
        isOpen={showDeleteModal}
        title={`Are you sure you want to delete `}
        topic={selectedWorktype?.worktype}
        setIsOpen={setShowDeleteModal}
        handleConfirm={handleConfirmDelete}
      />
    </>
  );
}
